import * as React from 'react';

import * as styles from './MortgageBannerSection.css';

export const MortgageBannerSection: React.FC = ({ children }) => (
  <div className={styles['mortgage-banner']}>{children}</div>
);
